import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ButtonIcon } from '@statsbomb/kitbag-components';
import VideoPanel from '../../../components/Video/VideoPanel';
import {
  ModalStyleWrapper,
  VideoModalHeader,
} from '../../../components/Video/VideoModal.styles';

// Reuse the shared VideoModal sizing (ModalStyleWrapper + VideoModalHeader) so
// the player opens at the same large size as elsewhere in the app - the
// wrapper sizes the dialog to calc(100% - 4rem)/max 1740px and absolutely
// fills the inner video panel to 100%.
const GameVideoModal = ({ isOpen, onClose, playIds, title }) => (
  <ModalStyleWrapper>
    <Modal
      id="game-video-modal"
      isOpen={isOpen}
      onEscape={onClose}
      onCancel={onClose}
    >
      {isOpen && playIds.length > 0 && (
        <div>
          <VideoModalHeader>
            <ModalHeader
              id="game-video-modal-header"
              testId="game-video-modal-header"
            >
              {title}
            </ModalHeader>
            <div className="close">
              <ButtonIcon
                onClick={onClose}
                variant="ghost"
                shape="pill"
                size="small"
                icon="Close"
                title="Close"
              />
            </div>
          </VideoModalHeader>
          <VideoPanel
            data={playIds.map((id) => ({ playId: String(id) }))}
            isModal
            fixedPlaylist
          />
        </div>
      )}
    </Modal>
  </ModalStyleWrapper>
);

GameVideoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  playIds: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
};

GameVideoModal.defaultProps = {
  playIds: [],
  title: 'Selected plays',
};

export default GameVideoModal;
